'use client';

import { PartnerLoader, useLoaderStore } from '~/components/PartnerLoader/PartnerLoader';
import styles from './OverviewTopBarLoader.module.css';

export const OverviewTopBarLoader = () => {
  const isActive = useLoaderStore((s) => s.isActive);
  const isProgressBarVisible = useLoaderStore((s) => s.isProgressBarVisible);
  if (!isActive || !isProgressBarVisible) return null;

  return (
    <div className={styles.topBar}>
      <div className={styles.bar}>
        <PartnerLoader variant="topBar" interactive />
      </div>
    </div>
  );
};
